/**
 * @generated SignedSource<<714739a9597d162fabb4a65c8098c2ea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartSubmissionLayoutPageQuery$variables = {
  submissionId: string;
};
export type StartSubmissionLayoutPageQuery$data = {
  readonly landlordOnboardingSubmission: {
    readonly agentSearch: {
      readonly " $fragmentSpreads": FragmentRefs<"StartLiveAgentMap_search">;
    } | null | undefined;
  } | null | undefined;
};
export type StartSubmissionLayoutPageQuery = {
  response: StartSubmissionLayoutPageQuery$data;
  variables: StartSubmissionLayoutPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "submissionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartSubmissionLayoutPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordAgentSearch",
            "kind": "LinkedField",
            "name": "agentSearch",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StartLiveAgentMap_search"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StartSubmissionLayoutPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordAgentSearch",
            "kind": "LinkedField",
            "name": "agentSearch",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordAgentMapPin",
                "kind": "LinkedField",
                "name": "mapPins",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "147834de08ff34ff5783979061bdb2f4",
    "id": null,
    "metadata": {},
    "name": "StartSubmissionLayoutPageQuery",
    "operationKind": "query",
    "text": "query StartSubmissionLayoutPageQuery(\n  $submissionId: ID!\n) {\n  landlordOnboardingSubmission(id: $submissionId) {\n    agentSearch {\n      ...StartLiveAgentMap_search\n      id\n    }\n    id\n  }\n}\n\nfragment CompareAgentMap_pin on LandlordAgentMapPin {\n  id\n  name\n  latitude\n  longitude\n  state\n}\n\nfragment StartLiveAgentMap_search on LandlordAgentSearch {\n  latitude\n  longitude\n  mapPins {\n    ...CompareAgentMap_pin\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bdf070af82377c9852bf0844f3601cc";

export default node;
